import { render } from "./ResetPasswordView.vue?vue&type=template&id=0d4d7012&scoped=true&ts=true"
import script from "./ResetPasswordView.ts?vue&type=script&lang=ts"
export * from "./ResetPasswordView.ts?vue&type=script&lang=ts"

import "./ResetPasswordView.scss?vue&type=style&index=0&id=0d4d7012&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d4d7012"]])

export default __exports__